module.exports = __webpack_public_path__ + "assets/img/icon_lesson_word.fa2b74f5.png";